import { UploadOutlined } from '@ant-design/icons';
import { Button, Upload } from 'antd';
import React, { ReactElement } from 'react';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import IApplication from '~Api/Application/IApplication';
import IBorrower from '~Api/Application/IBorrower';
import ConditionDocumentApprovalStatusEnum from '~Api/Application/ConditionDocumentApprovalStatusEnum';
import ConditionTypeEnum from '~Api/Application/ConditionTypeEnum';
import IConditionDocument from '~Api/Application/IConditionDocument';
import { applicationConditionDocumentsAddAction } from '~Applications/actions';
import IApplicationProperty from '~Api/Application/IApplicationProperty';

export default function UploadConditionDocument(props: {
    application: IApplication;
    applicationBorrower?: IBorrower;
    applicationProperty?: IApplicationProperty;
    conditionType?: ConditionTypeEnum;
    conditionUuid?: string;
}): ReactElement {
    const {
        application,
        applicationBorrower,
        applicationProperty,
        conditionType,
        conditionUuid,
    } = props;

    const dispatch: Dispatch = useDispatch();

    const beforeUpload: (file: File) => boolean = (file: File): boolean => {
        const conditionDocument: IConditionDocument = {
            approvalStatus: ConditionDocumentApprovalStatusEnum.Pending,
            conditionType,
            conditionUuid,
        };

        if (applicationBorrower) {
            conditionDocument.applicationBorrowerUuid = applicationBorrower.uuid;
        }else if (applicationProperty) {
            conditionDocument.applicationPropertyUuid = applicationProperty.uuid;
        } else {
            conditionDocument.applicationUuid = application.uuid;
        }

        dispatch(applicationConditionDocumentsAddAction(application.uuid, file, conditionDocument));

        return false;
    };

    return (
        <Upload className='add-document' beforeUpload={beforeUpload} showUploadList={false}>
            <Button type='link'><UploadOutlined/></Button>
        </Upload>
    );
}
